export default __webpack_public_path__ + "static/media/CarImages.PicantoMedium2.85e7e6dd.jpg";